import {
    Collection,
    BaseCollections
} from './base';

Collection.Space = class Space extends Collection.Base {

    checkItem(item) {
        return super.checkItem(...arguments);
    }
};


angular.module('BB').provider('SpaceCollections', () => {
        return {
            $get() {
                return new BaseCollections();
            }
        };
    }
);




// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_collections/space_collections.provider.js